import {FC, useEffect} from 'react'
import InlineSVG from 'react-inlinesvg'
import {useDispatch} from 'react-redux'
import {GButton} from 'src/app/components/Libs'
import {IOnboardingAgent} from 'src/app/models'
import OnboardingRedux from 'src/app/store/Onboarding/OnboardingRedux'
import {toAbsoluteUrl} from 'src/app/utils/asset-helpers.utils'

const ExpiredSectionAgent: FC<{data?: IOnboardingAgent}> = ({data}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(OnboardingRedux.actions.setEmpty())
    //eslint-disable-next-line
  }, [])

  return (
    <div className='flex flex-col items-center justify-center w-full h-full bg-neutral-25'>
      <InlineSVG src={toAbsoluteUrl('/media/image/image_expired_link.svg')} />
      <div className='mt-6 font-medium text-center text-neutral-900 text-fs-4 min-w-[320px] px-6'>
        Akun tidak ditemukan
      </div>
      <div className='mt-2 text-center text-neutral-600 text-fs-7 min-w-[320px] px-6'>
        Hubungi Admin untuk keterangan lebih lanjut.
      </div>
      <div className='mt-8 text-center'>
        <div>
          <a href={`mailto:${data?.cs_email}?subject=Saya%20Membutuhkan%20Bantuan%20Admin`}>
            <GButton size={'large'} className='w-[240px]'>
              Hubungi via Email
            </GButton>
          </a>
        </div>
        <div className='mt-2'>
          <a href={`tel:${data?.cs_mobile_number}`}>
            <GButton size={'large'} className='w-[240px]' variant='OUTLINED'>
              Hubungi via Telepon
            </GButton>
          </a>
        </div>
      </div>
    </div>
  )
}

export default ExpiredSectionAgent
